import { render, staticRenderFns } from "./PackagesDa.vue?vue&type=template&id=b3e37d7a&scoped=true&"
import script from "./PackagesDa.vue?vue&type=script&lang=js&"
export * from "./PackagesDa.vue?vue&type=script&lang=js&"
import style0 from "./PackagesDa.vue?vue&type=style&index=0&id=b3e37d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e37d7a",
  null
  
)

export default component.exports